import { render, staticRenderFns } from "./AlertCategoryFilter.vue?vue&type=template&id=8fb0214a&scoped=true"
import script from "./AlertCategoryFilter.vue?vue&type=script&lang=js"
export * from "./AlertCategoryFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fb0214a",
  null
  
)

export default component.exports